/**
 * Нажатие досталось окну, меню или списку поверх приложения — или его уже
 * взял кто-то другой. Клавиши, что слушают всё окно (Ctrl+P, Ctrl+F,
 * Shift+PageUp…), тогда молчат: иначе они переключали бы то, что лежит под
 * открытыми настройками, и отнимали у полей их собственные сочетания.
 */
export function overlaid(event: Event): boolean {
  if (event.defaultPrevented) return true;
  const target = event.target as HTMLElement | null;
  return !!target?.closest?.("[role=dialog], [role=alertdialog], [role=menu], [role=listbox]");
}
